// extracted by mini-css-extract-plugin
export var SectionBanner = "banner-module--SectionBanner--5cf3a";
export var TextContainer = "banner-module--TextContainer--8eb80";
export var imgContainer1 = "banner-module--imgContainer1--f137c";
export var imgContainer2 = "banner-module--imgContainer2--82c35";